<app-spinner [showSpinner]="showSpinner" color="primary" size="lg" ></app-spinner>
